import styled from 'styled-components'
import media from 'utils/media'
import { Row, Col } from 'components/Grid'

export const StyledRow = styled(Row)`
  margin-top: ${({ marginTopMb }) => marginTopMb}px;

  ${media.greaterThan('sm')`
    margin-top: ${({ marginTop }) => marginTop}px;
  `}
`
export const Title = styled.h4`
  margin: auto;
  text-transform: uppercase;
`
export const ChildCol = styled(Col)`
${media.greaterThan('lg')`
  .slick-slider  {
    .slick-track > :nth-child(odd) {
      display: flex;
      justify-content: flex-end;
      & > div {
        margin-right: 30px;
      }
    }
    .slick-track > :nth-child(even) {
      display: flex;
      justify-content: flex-start;
      & > div {
          margin-left: 30px;
      }
    }
  }
`}
`
export const MaxCountCol = styled(Col)`
  ${media.greaterThan('sm')`
    display: flex;
    justify-content: center;
  `}
`
